import React from 'react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { SemanticToastContainer } from 'react-semantic-toasts';
import {
  getCouponsList,
  changeCouponsFilter,
  showEditorModal,
  changeCouponStatus,
  showCouponToggleConfirmation,
  showCouponDetailsRoutine,
  showCouponDetailsModal,
  resetEditorModal,
  changeCouponLogsPage,
  setCouponEditorErrorMessage,
  createCouponForm,
} from 'state/coupons/actions';
import ActionBar from 'pages/Coupons/ActionBar';
import CouponEditorModal from 'pages/Coupons/CouponEditorModal';
import CouponToggleConfirmationModal from 'pages/Coupons/CouponToggleConfirmationModal';
import CouponDetailsModal from 'pages/Coupons/CouponDetailsModal';
import CouponsList from 'pages/Coupons/CouponsList';

export class CouponsPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { filters } = this.props;
    this.loadFirstCouponList(filters);
  }

  onPageChange(newPage) {
    const {
      dispatch,
      coupons: { pageSize },
      filters,
    } = this.props;
    dispatch(getCouponsList({ pageNumber: newPage, pageSize }, filters));
  }

  onApplyFilter(filters) {
    const { dispatch } = this.props;
    dispatch(changeCouponsFilter(filters));
    this.loadFirstCouponList(filters);
  }

  onCreateButtonClicked() {
    this.onResetFormModal();
    const { dispatch } = this.props;
    dispatch(setCouponEditorErrorMessage(null));
    dispatch(showEditorModal(true));
  }

  onCouponEditorSubmit(values, dispatch) {
    const {
      coupons: { pageSize },
      filters,
    } = this.props;

    return createCouponForm(
      {
        coupon: values,
        paging: { pageNumber: 1, pageSize },
        filters,
      },
      dispatch
    );
  }

  onResetFormModal() {
    const { dispatch } = this.props;
    dispatch(resetEditorModal());
  }

  onCouponStatusChanged(couponCode, currentStatus) {
    const { dispatch } = this.props;
    dispatch(change('coupon-toggle', 'code', couponCode));
    const action = currentStatus === 'OPEN' ? 'DEACTIVATE' : 'ACTIVATE';
    dispatch(change('coupon-toggle', 'action', action));
    dispatch(showCouponToggleConfirmation(true, couponCode, action));
  }

  onSubmitCouponStatusChange({ code, action }) {
    const {
      dispatch,
      coupons: { pageNumber, pageSize },
      filters,
    } = this.props;
    dispatch(
      changeCouponStatus(code, action, { pageNumber, pageSize }, filters)
    );
  }

  onShowingCouponDetails(couponCode) {
    const {
      dispatch,
      couponDetailsModal: {
        logs: { pageSize },
      },
    } = this.props;
    dispatch(showCouponDetailsRoutine(couponCode, 1, pageSize));
  }

  onCouponLogsPageChange(pageNumber) {
    const {
      dispatch,
      couponDetailsModal: {
        coupon: { code },
        logs: { pageSize },
      },
    } = this.props;
    dispatch(changeCouponLogsPage(code, pageNumber, pageSize));
  }

  loadFirstCouponList(filters) {
    const {
      dispatch,
      coupons: { pageSize },
    } = this.props;
    dispatch(getCouponsList({ pageNumber: 1, pageSize }, filters));
  }

  render() {
    const {
      coupons,
      pageIsLoading,
      editorModalShown,
      dispatch,
      editorModalError: { message: modalErrorMessage },
      editorModalLoading,
      couponToggleConfirmation,
      couponDetailsModal,
      assignMerchantsModalShown,
      businessIdValidationResult,
    } = this.props;
    return (
      <div>
        <SemanticToastContainer position="top-right" />
        <h1>Coupons list</h1>
        <br />
        <ActionBar
          onApplyFilter={this.onApplyFilter}
          onCreateButtonClicked={this.onCreateButtonClicked}
          isLoading={pageIsLoading}
        />
        <CouponsList
          coupons={coupons}
          onPageChange={this.onPageChange}
          isLoading={pageIsLoading}
          onCouponStatusChanged={this.onCouponStatusChanged}
          onShowingCouponDetails={this.onShowingCouponDetails}
        />
        <CouponEditorModal
          open={editorModalShown}
          onClose={() => dispatch(showEditorModal(false))}
          onSubmit={this.onCouponEditorSubmit}
          onReset={this.onResetFormModal}
          errorMessage={modalErrorMessage}
          isLoading={editorModalLoading}
          assignMerchantsModalShown={assignMerchantsModalShown}
          businessIdValidationResult={businessIdValidationResult}
        />
        <CouponToggleConfirmationModal
          shown={couponToggleConfirmation.shown}
          couponCode={couponToggleConfirmation.couponCode}
          action={couponToggleConfirmation.action}
          onClose={() => dispatch(showCouponToggleConfirmation(false))}
          isLoading={couponToggleConfirmation.isLoading}
          onSubmit={this.onSubmitCouponStatusChange}
        />
        <CouponDetailsModal
          shown={couponDetailsModal.shown}
          onClose={() => dispatch(showCouponDetailsModal(false))}
          coupon={couponDetailsModal.coupon}
          isLoading={couponDetailsModal.isLoading}
          isLogsLoading={couponDetailsModal.isLogsLoading}
          errorShown={couponDetailsModal.errorShown}
          errorMessage={couponDetailsModal.errorMessage}
          logs={couponDetailsModal.logs}
          onCouponLogsPageChange={this.onCouponLogsPageChange}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    coupons: state.billingCoupon.coupons,
    pageIsLoading: state.loadingSpinner,
    filters: state.billingCoupon.filters,
    editorModalShown: state.billingCoupon.editorModalShown,
    editorModalError: state.billingCoupon.editorModalError,
    editorModalLoading: state.billingCoupon.editorModalLoading,
    couponToggleConfirmation: state.billingCoupon.couponToggleConfirmation,
    couponDetailsModal: state.billingCoupon.couponDetailsModal,
    assignMerchantsModalShown: state.billingCoupon.assignMerchantsModalShown,
    businessIdValidationResult: state.billingCoupon.businessIdValidationResult,
  };
};

CouponsPage.propTypes = {
  coupons: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        code: PropTypes.string,
        status: PropTypes.string,
        amount: PropTypes.number,
        global_quota: PropTypes.number,
        used_quota: PropTypes.number,
      })
    ),
    pageNumber: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  pageIsLoading: PropTypes.bool.isRequired,
  filters: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    status: PropTypes.string,
    statusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ),
    searchKeyword: PropTypes.string.isRequired,
  }).isRequired,
  editorModalShown: PropTypes.bool.isRequired,
  editorModalError: PropTypes.shape({
    message: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  editorModalLoading: PropTypes.bool.isRequired,
  couponToggleConfirmation: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    couponCode: PropTypes.string,
    action: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
  }).isRequired,
  couponDetailsModal: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    coupon: PropTypes.object,
    logs: PropTypes.shape({
      list: PropTypes.array,
      pageNumber: PropTypes.number.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired,
    }),
    isLoading: PropTypes.bool.isRequired,
    isLogsLoading: PropTypes.bool.isRequired,
    errorShown: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
  }).isRequired,
  assignMerchantsModalShown: PropTypes.bool.isRequired,
  businessIdValidationResult: PropTypes.object,
};

CouponsPage.defaultProps = {
  businessIdValidationResult: null,
};

export default connect(mapStateToProps)(CouponsPage);
